// extracted by mini-css-extract-plugin
export var copyIcon = "_r3-2";
export var discountCard = "_r3-0";
export var discountCode = "_r3-3";
export var discountContent = "_r3-1";
export var loadingCard = "_r3-4";